import { render, staticRenderFns } from "./EnterOrderItem.vue?vue&type=template&id=45678ad8&scoped=true"
import script from "./EnterOrderItem.vue?vue&type=script&lang=js"
export * from "./EnterOrderItem.vue?vue&type=script&lang=js"
import style0 from "./EnterOrderItem.vue?vue&type=style&index=0&id=45678ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45678ad8",
  null
  
)

export default component.exports